export interface PlanPillState {
  labelText: string
  color: string
  backgroundColor: string
}

// NOTE: These are not display labels, just a "label" as a thing which has a display
// text and colors (defined elsewhere)
export enum PlanPillLabel {
  FREE = 'FREE',
  PRO = 'PRO',
  PRO_PLUS = 'PRO PLUS',
  PRO_FLEX = 'PRO FLEX',
  PILOT = 'TRIAL',
  ENTERPRISE = 'ENTERPRISE'
}
